(function () {
  var money = function (c) {
    return (c / 100).toFixed(2).replace('.', ',') + ' $';
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var drawer = $('[data-drawer]'), scrim = $('[data-scrim]');
  function toggle(on) {
    if (!drawer) return;
    drawer.classList.toggle('on', on);
    scrim.classList.toggle('on', on);
  }
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); toggle(true); render(); });
  });
  if (scrim) scrim.addEventListener('click', function () { toggle(false); });
  var close = $('[data-close]');
  if (close) close.addEventListener('click', function () { toggle(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });

  function render() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var body = $('[data-drawer-body]');
      var cnt = $('[data-cart-count]');
      var sub = $('[data-subtotal]');
      if (cnt) cnt.textContent = cart.item_count;
      if (sub) sub.textContent = money(cart.total_price);
      if (!body) return;
      if (!cart.items.length) { body.innerHTML = '<p class="empty">Votre panier est vide.</p>'; return; }
      body.innerHTML = cart.items.map(function (i) {
        var img = i.image ? '<img src="' + i.image + '" alt="">' : '';
        return '<div class="line">' + img +
          '<div class="line-info"><strong>' + i.product_title + '</strong>' +
          money(i.final_line_price) + ' &middot; qté ' + i.quantity +
          '</div></div>';
      }).join('');
    });
  }
  render();

  /* ajout au panier sans rechargement */
  $$('form[action$="/cart/add"]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Ajout…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
        .then(function (r) { return r.json(); })
        .then(function () { render(); toggle(true); })
        .catch(function () { f.submit(); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        });
    });
  });

  /* quantité */
  $$('[data-qty]').forEach(function (w) {
    var inp = w.querySelector('input');
    w.querySelector('[data-minus]').addEventListener('click', function () {
      inp.value = Math.max(1, parseInt(inp.value, 10) - 1);
    });
    w.querySelector('[data-plus]').addEventListener('click', function () {
      inp.value = parseInt(inp.value, 10) + 1;
    });
  });

  /* galerie produit */
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gal-main]');
    $$('button', g).forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.full;
        $$('button', g).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
  });
})();
